import React, { useEffect, useState, useContext, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import "assets/scss/datatables.scss"

import GlobalState from "contexts/GlobalState"
import Breadcrumbs from "components/Common/Breadcrumb"
import QuickGuide from "components/QuickGuides/QuickGuide"

import img1 from "../../assets/images/other/img-6.jpg"
import iconVideocall from "../../assets/images/icons/videocall.svg"
import iconApp from "../../assets/images/icons/app.svg"
import iconMedicine from "../../assets/images/icons/medicineReminder.svg"
import iconGroupvideo from "../../assets/images/icons/groupvideo-icon.svg"
import iconWebpageAlt from "../../assets/images/icons/webIconAlt.svg"
import ReleaseListItem from "./ReleaseListItem"
import DisturbanceListItem from "./DisturbanceListItem"

import {
  getPublicReleaseNotes,
  getPublicStatusReports,
} from "helpers/database_helper"
import {
  getLocaleText,
  getLottieLoadingOptions,
  showToast,
} from "utils/general"

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Row,
  CardTitle,
  Container,
  NavItem,
  TabContent,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  TabPane,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  NavLink,
} from "reactstrap"
import { Tooltip } from "antd"

import SimpleBar from "simplebar-react"
import moment from "moment"
import Lottie from "react-lottie"
import { DateTime } from 'luxon';
import HoursRangeConverter from "./HoursRangeConverter"

const LandingPage = props => {
  const [cogOpen, setCogOpen] = useState(false)

  const [state] = useContext(GlobalState)

  // Entries related
  const [activeTab, setActiveTab] = useState("1")
  const [firstName, setFirstName] = useState("")
  const [supportType, setSupportType] = useState(null)

  const [releaseNotes, setReleaseNotes] = useState([])
  const [releaseNotesLoading, setReleaseNotesLoading] = useState(true)
  const [releaseNotesNone, setReleaseNotesNone] = useState(false)

  const [statusReports, setStatusReports] = useState([])
  const [statusReportsLoading, setStatusReportsLoading] = useState(true)
  const [statusReportsNone, setStatusReportsNone] = useState(false)
  const [ongoingIssues, setOngoingIssues] = useState(false)
  const [resolvedIssues, setResolvedIssues] = useState(false)

  const [supportEmail, setSupportEmail] = useState("")
  const [supportGsm, setSupportGsm] = useState("040 6577 343")
  const [supportGsm2, setSupportGsm2] = useState()
  const [showFaq, setShowFaq] = useState(false)
  const [secureSupportMail, setSecureSupportMail] = useState(
    "https://secmail.com/send/NDVSnGhL"
  )

  const [showPdf, setShowPdf] = useState(false)
  const [quickGuide, setQuickGuide] = useState(false)

  // Check if card is null/"true"/"false" in localStorage
  const [welcomeCardOpen, setWelcomeCardOpen] = useState(
    localStorage.getItem("welcomeCard") !== "false"
  )

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = props.t("Front page") + " | Suvanto Care"
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Get support type from user
  useEffect(() => {
    if (state.authUser != null) {
      const user = JSON.parse(state.authUser)
      const name = user.firstName
      setFirstName(name)
      setSupportType(user.supportType)
      if (user.supportType != null) {
        let prefix, domain
        switch (user.supportType) {
          // Elisa
          case 1:
            prefix = "digihoiva.tuki"
            domain = "elisa.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("050 3571 727")
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // 2M-IT
          case 2:
            prefix = "servicedesk"
            domain = "2m-it.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm(null)
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // Laajennettu tuki
          case 3:
            prefix = "tuki"
            domain = "suvantocare.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("040 6577 343")
            setSupportGsm2("040 6577 378")
            setShowFaq(true)
            setSecureSupportMail("https://secmail.com/send/NDVSnGhL")
            break
          // Elisa laajennettu tuki
          case 4:
            prefix = "digihoiva.tuki"
            domain = "elisa.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("050 3571 727")
            setSupportGsm2("040 6577 378")
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // 2M-IT laajennettu, ei oikeita tietoja vielä
          case 5:
            prefix = "sovellustuki"
            domain = "2m-it.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("010 198 015")
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // Istekki-Pirha
          case 6:
            prefix = "1144.kayttotuki"
            domain = "pirha.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("03 3117 1144")
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // Istekki-PSHVA
          case 7:
            prefix = "asiakaspalvelut"
            domain = "istekki.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("017 173 900")
            setShowFaq(false)
            setSecureSupportMail(null)
            break
          // Norway
          case 20:
            prefix = "support"
            domain = "suvantocare.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("+358 93 152 3760")
            setShowFaq(false)
            setSecureSupportMail("https://secmail.com/send/NDVSnGhL")
            break
          default:
            prefix = "tuki"
            domain = "suvantocare.fi"
            setSupportEmail(prefix + "@" + domain)
            setSupportGsm("040 6577 343")
            setShowFaq(true)
            setSecureSupportMail("https://secmail.com/send/NDVSnGhL")
            break
        }
      }
    }
  }, [])

  // Release notes
  useEffect(() => {
    getPublicReleaseNotes(abortRef.current)
      .then(notes => {
        let array = []
        for (const note of notes) {
          let niceDate = moment(note.informed_date).format("DD.MM.YYYY")
          let temp = new Object()
          temp.guid = note.guid
          temp.id = note.id
          temp.date = niceDate
          temp.updated = note.updated
            ? moment(note.updated).format("DD.MM.YYYY HH:mm")
            : null
          temp.title = note.target + " v." + note.version
          temp.type = note.type == 1 ? "Hotfix" : "Update"
          temp.version = note.version

          if (note.release_date) {
            temp.releaseDate = moment(note.release_date).format("DD.MM.YYYY")
          }

          switch (note.target) {
            case 1:
              temp.target = "ReleaseNoteTypes.1" // Suvanto Care app
              temp.img = iconApp
              break
            case 2:
              temp.target = "ReleaseNoteTypes.2" // Suvanto Health
              temp.img = iconMedicine
              break
            case 3:
              temp.target = "ReleaseNoteTypes.3" // Suvanto Video
              temp.img = iconVideocall
              break
            case 4:
              temp.target = "ReleaseNoteTypes.4" // Suvanto Care webpage
              temp.img = iconWebpageAlt
              break
            case 5:
              temp.target = "ReleaseNoteTypes.5" // Group video call
              temp.img = iconGroupvideo
              break
            /*case 6:
              temp.target = "Medicine reminder"
              temp.img = iconMedicine
              break*/
            default:
              temp.target = "Unknown"
              break
          }

          switch (note.status) {
            case 1:
              temp.status = "Upcoming"
              break
            case 2:
              temp.status = "Waiting for release"
              break
            case 3:
              temp.status = "Postponed"
              break
            case 4:
              temp.status = "Published"
              break
            default:
              temp.status = "Unknown"
              break
          }

          array.push(temp)
        }
        setReleaseNotes(array)
        setReleaseNotesLoading(false)
        if (notes.length == 0) setReleaseNotesNone(true)
      })
      .catch(err => {
        console.log("Release notes error: ", err)
        setReleaseNotesLoading(false)
        setReleaseNotesNone(true)
      })
  }, [])

  // Status reports
  useEffect(() => {
    getPublicStatusReports(abortRef.current)
      .then(reports => {
        let issues = false
        let resolved = false
        let array = []
        for (const rep of reports) {
          let niceDate = moment(rep.start_time).format("DD.MM.YYYY HH:mm")
          if (rep.end_time) {
            let endDate = new Date(rep.end_time)
            if (endDate > 0) {
              let endDateNice = moment(rep.end_time).format("DD.MM.YYYY HH:mm")
              niceDate = niceDate + " - " + endDateNice
            }
          }

          let temp = new Object()
          temp.guid = rep.guid
          temp.id = rep.id
          temp.date = niceDate
          temp.title = rep.header_fi

          let lang = getLocaleText() ?? "en"
          switch (lang) {
            case "en":
              if (rep.header_en) temp.title = rep.header_en
              break
            case "sv":
              if (rep.header_sv) temp.title = rep.header_sv
              break
          }

          let targets = []
          let split = rep.target_groups.split(",")
          for (const target of split) {
            switch (target) {
              case "1":
                targets.push("Suvanto Care app")
                break
              case "2":
                targets.push("Video call")
                break
              case "3":
                targets.push("Group video call")
                break
              case "4":
                targets.push("Carephone")
                break
              case "5":
                targets.push("Medicine reminder")
                break
              case "6":
                targets.push("Suvanto On the Go")
                break
              case "7":
                targets.push("Suvanto Home")
                break
              case "8":
                targets.push("Smartlock")
                break
              case "9":
                targets.push("Suvanto Care webpage")
                break
              case "10":
                targets.push("Smartwatch")
                break
            }
          }
          temp.targets = targets

          switch (rep.current_status) {
            case 1:
              issues = true
              temp.status = "Service outage"
              temp.img = img1
              temp.color = "#f46a6a"
              break
            case 2:
              issues = true
              temp.status = "Service disruption"
              temp.img = img1
              temp.color = "#f1b44c"
              break
            case 3:
              resolved = true
              temp.status = "Service operational"
              temp.img = img1
              temp.color = "#34c38f"
              break
          }

          array.push(temp)
        }

        setStatusReports(array)
        setOngoingIssues(issues)
        setResolvedIssues(resolved)

        // Show disturbance notices automatically if ongoing issues
        if (issues) toggle("2")

        setStatusReportsLoading(false)
        if (reports.length == 0) setStatusReportsNone(true)
      })
      .catch(err => {
        console.log("Status reports error: ", err)
        setStatusReportsLoading(false)
        setStatusReportsNone(true)
      })
  }, [])

  // Change card view
  const changeView = i => {
    switch (i) {
      case 1: {
        let value = JSON.stringify(!welcomeCardOpen)
        setWelcomeCardOpen(prevState => !prevState)
        localStorage.setItem("welcomeCard", value)
        return
      }
      case 2:
        // TODO: rest of cards modify
        setWelcomeCardOpen(prevState => !prevState)
        return
    }
  }

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  function getUserManual() {
    const lang = localStorage.getItem("i18nextLng") || "fi"
    if (lang.startsWith("sv")) return "/files/Användarmanual.pdf"
    if (lang.startsWith("en")) return "/files/UserManual.pdf"
    return "/files/Käyttöohje.pdf"
  }

  const downloadManual = () => {
    const manualPath = getUserManual()
    fetch(manualPath).then(res =>
      res.blob().then(blob => {
        const url = globalThis.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = props.t("Instructions") + ".pdf"
        a.click()
      })
    )
  }

  return (
    <>
      <div className="page-content">
        <Container fluid className={quickGuide ? "quick-guide-open" : ""}>
          <Breadcrumbs
            className="breadcrumb m-0 justify-content-center"
            title={props.t("Front page")}
            breadcrumbItem={
              <>
                <div className="d-inline-block mb-0">
                  <Dropdown
                    isOpen={cogOpen}
                    toggle={() => setCogOpen(!cogOpen)}
                  >
                    <Tooltip
                      title={props.t("View settings")}
                      trigger={["hover", "focus"]}
                    >
                      <DropdownToggle
                        aria-haspopup="menu"
                        aria-label={props.t("View settings")}
                        tag="button"
                        id="cog-button"
                        className="btn focus-grey d-inline-flex me-1"
                        style={{ padding: "6px 8px" }}
                      >
                        <i className="bx bx-cog font-size-16"></i>
                      </DropdownToggle>
                    </Tooltip>
                    <DropdownMenu className="dropdown-menu-end py-2 px-3">
                      <h6 className="pb-2 pt-1">{props.t("Modify view")}</h6>
                      <div className="pb-1 text-muted">
                        <input
                          type="checkbox"
                          id="welcomecard"
                          autoComplete="off"
                          className="form-check-input  me-2"
                          defaultChecked={!!welcomeCardOpen}
                          onChange={() => {
                            changeView(1)
                          }}
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="welcomecard"
                        >
                          <p className="mb-2">{props.t("Welcome card")}</p>
                        </label>
                      </div>
                      {/* <div className="pb-1 text-muted">
                        <input
                          disabled={true}
                          type="checkbox"
                          id="welcomecard"
                          className="form-check-input me-2 "
                          defaultChecked={true}
                          // onChange={() => {
                          //   changeView(2)
                          // }}
                        ></input>
                        <label
                          className="form-check-label"
                          htmlFor="welcomecard"
                        >
                          <p className="mb-2">{props.t("Support card")}</p>
                        </label>
                      </div>
                      <div className="pb-1 text-muted">
                        <input
                          disabled={true}
                          type="checkbox"
                          id="welcomecard"
                          className="form-check-input me-2 "
                          defaultChecked={true}
                          // onChange={() => {
                          //   changeView(3)
                          // }}
                        ></input>
                        <label
                          className="form-check-label "
                          htmlFor="welcomecard"
                        >
                          <p className="mb-2">{props.t("Bulletins card")}</p>
                        </label>
                      </div> */}
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <div style={{ display: "inline-block" }}>
                  <QuickGuide
                    source="landingPage"
                    title="Front page"
                    isOpen={quickGuide}
                    setIsOpen={setQuickGuide}
                  />
                </div>
              </>
            }
          />
          <Col lg="12">
            <Row>
              <Col lg={quickGuide ? 12 : 6}>
                <Collapse isOpen={welcomeCardOpen}>
                  <Card>
                    <div className="p-3 ms-2">
                      <h4 className="text-primary mt-1 mb-3">
                        {props.t("Hi")}, {firstName}!
                      </h4>
                      <button
                        type="button"
                        onClick={() => {
                          changeView(1)
                          showToast(
                            props.t(
                              "You can set the card to be visible from the settings button on the right"
                            ),
                            "info"
                          )
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <p className="my-1">
                        {props.t("Welcome to the Suvanto Care interface")}.
                      </p>
                    </div>
                  </Card>
                </Collapse>

                {/* SUPPORT CARD */}
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3">{props.t("Instructions")}</CardTitle>
                    <Row>
                      <Col>
                        <p className="mb-0 text-muted">
                          {supportType == 6 || supportType == 7 ? (
                            <>{props.t("LandingPageInstructions.4")}.</>
                          ) : (
                            <>{props.t("LandingPageInstructions.3")}.</>
                          )}
                        </p>

                        <div className="mt-2">
                          <a
                            className="landingpage-link"
                            href={
                              supportType == 6 || supportType == 7
                                ? "https://suvanto.help/istekki"
                                : "https://suvanto.info"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "list-item",
                              listStylePosition: "inside",
                            }}
                          >
                            {supportType == 6 || supportType == 7
                              ? props.t("Help portal")
                              : props.t("Instructional videos")}
                          </a>
                        </div>

                        <p className="mt-3 text-muted">
                          {props.t("LandingPageInstructions.6")} {""}
                          <i className="bx bx-book-content"></i> {""}
                          {props.t("LandingPageInstructions.7")}.
                        </p>

                        <p className="text-muted">
                          {props.t("LandingPageInstructions.5")}.
                        </p>

                        <div className="mb-1">
                          <Tooltip
                            title={props.t("Open manual")}
                            trigger={["hover", "focus"]}
                          >
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => setShowPdf(!showPdf)}
                              style={{
                                height: "40px",
                                borderRadius: "0.25rem 0 0 0.25rem",
                              }}
                            >
                              <i className="mdi mdi-file-outline me-2" />
                              {props.t("Instructions")}
                            </Button>
                          </Tooltip>
                          <Tooltip
                            title={props.t("Download manual")}
                            trigger={["hover", "focus"]}
                            placement="right"
                          >
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => downloadManual()}
                              style={{
                                height: "40px",
                                borderRadius: "0 0.25rem 0.25rem 0",
                                borderLeft: "2px solid #FFFFFF4D",
                              }}
                            >
                              <i
                                className="mdi mdi-download"
                                style={{
                                  fontSize: "16px",
                                }}
                              ></i>
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody>
                    {/* <hr className="text-gray" /> */}
                    <CardTitle className="mb-3">{props.t("Support")}</CardTitle>

                    <div>
                      {supportType !== 6 && supportType !== 7 ? (
                        // Other support
                        <p className="text-muted">
                          {props.t("Support description 1")}{" "}
                          {(supportType === 3 || supportType === 4) && (
                            <>{props.t("Support description 4")}</>
                          )}
                          {(supportType === 0 || supportType === 1) && (
                            <>{props.t("Support description 3")}</>
                          )}
                        </p>
                      ) : (
                        // Istekki support
                        <>
                          <p className="text-muted">
                            {props.t("Support description Istekki")}
                          </p>
                          <p className="text-muted">
                            {props.t("Support description Istekki 2")}
                          </p>
                        </>
                      )}

                      {showFaq && (
                        <p className="text-muted">
                          {props.t("Support description 2")}{" "}
                          <a
                            aria-label="suvantocare.fi/kotona asumisen tukipalvelut"
                            className="text-primary landingpage-link"
                            href="https://www.suvantocare.fi/kotona-asumisen-tukipalvelut/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {props.t("this link")}.
                          </a>
                        </p>
                      )}
                      <Row>
                        <Col sm="8">
                          <div>
                            {supportType === 3 ||
                              supportType === 4 ||
                              supportType === 5 ? (
                              <p className="mt-3">
                                {props.t(
                                  "Extended support contact information"
                                )}
                              </p>
                            ) : (
                              <>
                                {supportType != 6 && supportType != 7 ? (
                                  // Other support
                                  <p className="mt-3">
                                    {props.t("Support contact information")}
                                  </p>
                                ) : (
                                  // Istekki support
                                  <></>
                                )}
                              </>
                            )}

                            <div className="text-muted">
                              {supportEmail != null && (
                                <p className="mb-1">
                                  <i className="mdi mdi-email align-middle text-primary me-1" />{" "}
                                  {supportEmail}
                                </p>
                              )}
                              {supportGsm != undefined && (
                                <p className="mb-1">
                                  <i className="mdi mdi-phone align-middle text-primary me-1" />{" "}
                                  {supportGsm}{" "}
                                  {supportType != 6 && supportType != 7 && supportType != 20 && (
                                    <>
                                      <span>{props.t("Support gsm 1")}</span>
                                    </>
                                  )}
                                  {supportType == 20 &&
                                    <>
                                      <span>{props.t("Support gsm dynamic")}</span>
                                      <HoursRangeConverter timeZone="Europe/Helsinki" range="08-16" />*
                                      <p className="mt-3 font-size-11" style={{marginBottom: "0px"}}>
                                        {"*" + props.t("Detected timezone") + ": " + DateTime.local().zoneName}
                                      </p>
                                    </>
                                  }
                                </p>

                              )}
                              {supportGsm2 != undefined && (
                                <p className="mb-1">
                                  <i className="mdi mdi-phone-plus align-middle text-primary me-1" />{" "}
                                  {supportGsm2} {props.t("Support gsm 2")}
                                </p>
                              )}
                            </div>
                          </div>
                        </Col>
                        {secureSupportMail != null && (
                          <Col sm="4">
                            <div>
                              <p className="mt-3">
                                {props.t("Secure support email")}
                              </p>

                              <div className="text-muted">
                                <button
                                  aria-label={props.t("Secure support email")}
                                  type="button"
                                  className="btn btn-secondary "
                                  onClick={() =>
                                    globalThis.open(
                                      secureSupportMail,
                                      "_blank",
                                      "noopener,noreferrer"
                                    )
                                  }
                                >
                                  {props.t("Navigate")}
                                  <i className="bx bxs-send font-size-12 align-middle ms-2 "></i>
                                </button>
                                {/* </a> */}
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col lg={quickGuide ? 12 : 6}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom">
                    <div className="d-flex flex-wrap">
                      <div className="me-2">
                        <h5 className="card-title mt-1 mb-0">
                          {props.t("Bulletins")}
                        </h5>
                      </div>
                      <ul className="nav nav-tabs nav-tabs-custom card-header-tabs ms-auto">
                        <NavItem>
                          <NavLink
                            to="#"
                            active={activeTab === "1"}
                            onClick={() => {
                              toggle("1")
                            }}
                          >
                            {props.t("Releases")}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            to="#"
                            active={activeTab === "2"}
                            onClick={() => {
                              toggle("2")
                            }}
                          >
                            {ongoingIssues && (
                              <span className="mdi mdi-alert-circle text-danger me-1" />
                            )}
                            {!ongoingIssues && resolvedIssues && (
                              <span className="mdi mdi-alert-circle text-success me-1" />
                            )}
                            {props.t("Error bulletins")}
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                  </CardHeader>

                  <CardBody className="pt-2">
                    <SimpleBar style={{ maxHeight: "100vh" }}>
                      <div>
                        {/* RELEASE NOTES */}
                        <TabContent activeTab={activeTab}>
                          <TabPane className="show" tabId="1">
                            {releaseNotesLoading && (
                              <Col lg={12} style={{ height: "100%" }}>
                                <Lottie
                                  options={getLottieLoadingOptions()}
                                  height={100}
                                  width={100}
                                />
                              </Col>
                            )}
                            {releaseNotesNone && (
                              <Col
                                className="mt-5 mb-5"
                                lg={12}
                                style={{ height: "100%" }}
                              >
                                <div className="text-center">
                                  <h6 className="text-muted">
                                    {props.t("No releases found")}
                                  </h6>
                                </div>
                              </Col>
                            )}
                            <ul className="list-group list-group-flush">
                              {releaseNotes.map(item => (
                                <li
                                  key={item.id}
                                  className="list-group-item pt-3 pb-2"
                                >
                                  <ReleaseListItem item={item} />
                                </li>
                              ))}
                            </ul>
                          </TabPane>

                          {/* STATUS REPORTS */}
                          <TabPane className="show" tabId="2">
                            {statusReportsLoading && (
                              <Col lg={12} style={{ height: "100%" }}>
                                <Lottie
                                  options={getLottieLoadingOptions()}
                                  height={100}
                                  width={100}
                                />
                              </Col>
                            )}
                            {statusReportsNone && (
                              <Col
                                className="mt-5 mb-5"
                                lg={12}
                                style={{ height: "100%" }}
                              >
                                <div className="text-center">
                                  <h6 className="text-muted">
                                    {props.t("No service issues found")}
                                  </h6>
                                </div>
                              </Col>
                            )}
                            <ul className="list-group list-group-flush">
                              {statusReports.map(item => (
                                <li
                                  key={item.id}
                                  className="list-group-item pt-3 pb-2"
                                >
                                  <DisturbanceListItem item={item} />
                                </li>
                              ))}
                            </ul>
                          </TabPane>
                        </TabContent>
                      </div>
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Modal isOpen={showPdf} toggle={() => setShowPdf(!showPdf)} size="xl">
            <ModalHeader toggle={() => setShowPdf(!showPdf)}>
              {props.t("Instructions")}
            </ModalHeader>
            <ModalBody
              style={{
                height: "85vh",
                border: "none",
                padding: 3,
                margin: 0,
              }}
            >
              <iframe
                src={getUserManual()}
                width="100%"
                height="100%"
                title="PDF"
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  )
}

LandingPage.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LandingPage)
